module.exports = __webpack_public_path__ + "devops-3-a126f611bfc483fd269d602ca41c7ba4.webp";